import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function ControlFiscalDeRutaDgr() {
  return (
    <ClipperPlaceholder title="Control Fiscal de Ruta - DGR" category="Operativas" />
  );
}
